import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../commons/cart.service';
import { CartProduct } from '../commons/models';
import { SessionService } from '../commons/session.service';
import { ConfiguratorApiService } from '../commons/configurator-api.service';
import { UtilitiesService } from '../commons/utilities.service';
// import { Angulartics2GoogleAnalytics, Angulartics2, Angulartics2Facebook } from 'angulartics2';


declare var ga: Function;
declare var fbq: Function;

@Component({
  selector: 'cart',
  template: require('./cart.component.html'),
})


export class CartComponent implements OnInit {

  public ecomm_prodids = '';
  public ecomm_value = 0;

  constructor(
    private router: Router,
    public cartService: CartService,
    private session: SessionService,
    public configApi: ConfiguratorApiService,
    public utilities: UtilitiesService,
    // public angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    // public angulartics2: Angulartics2,
    // public angulartics2Facebook: Angulartics2Facebook,
  ) {
  }


  removeCartProduct(idRow: Number) {
    this.cartService.removeCartRow(idRow);
    //console.log('removeCartProduct');
    this.cartService.cartCheckProducts();
  }

  removeCartConfirm(product: CartProduct) {
    alert('TO DO');
  }

  ngOnInit() {
    ////console.log('ngOnInit - cartCheckProducts:');
    this.cartService.cartCheckProducts();
    this.cartService.cartCheckCROPPED();

    ////console.log('cartProducts.forEach - ga(ecommerce:addItem...' );
    this.cartService.cart.cartProducts.forEach(prod => {
      this.ecomm_prodids += '\'' + prod.idProduct + '\',';
      this.ecomm_value += prod.totalPriceStatic;

      ga('ecommerce:addItem', {
        'id': prod.idProduct,
        'name': prod.productName,
        'sku': prod.idProduct,
        'category': prod.config.idModel,
        'price': (prod.price + prod.additionalPrice),
        'quantity': prod.quantity
      });
    });
    ga('ecommerce:send');


    this.ecomm_prodids = this.ecomm_prodids.substring(0, this.ecomm_prodids.length - 1);
    ////console.log('ecomm_prodid: ' + this.ecomm_prodids + ' - this.ecomm_value: ' + this.ecomm_value);

    fbq('track', 'AddToCart', {
      content_ids: [this.ecomm_prodids],
      content_type: 'product',
      value: this.ecomm_value,
      currency: 'EUR'
    });

  }

  addNewProduct() {
    if (this.cartService.cart.currentCartProduct != null) {
      this.cartService.cloneProduct();
    } else {
      this.cartService.addProduct(this.cartService.cart.currentCartProduct.idProduct, 1);
    }

    this.router.navigate(['/upload-photo']);
  }

  userEvt(idRowquantity: string) {
    let idRow: number = Number(idRowquantity.split(';')[0]);
    let quantity: number = Number(idRowquantity.split(';')[0]);
    //console.log('idRow:' + idRow + ' quantity:' + quantity);
    this.cartService.refreshQuantity(idRow, quantity);
  }

  getListParam(cli: CartProduct) {
    if (cli.params) {
      return cli.params.filter(p => p.reportTable === 'Navbar' && p.type !== 'Hidden');
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cart.component.ts